import { Auth0Provider } from '@auth0/auth0-react';
import { Provider } from 'jotai';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { env } from './utils/env';

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <Auth0Provider
    domain={env.DOMAIN}
    clientId={env.CLIENTID}
    authorizationParams={{
      redirect_uri: window.location.origin,
      audience: env.AUDIENCE
    }}
  >
    <Provider>
      <App />
    </Provider>
  </Auth0Provider>
);
